import {
  FILE_CHIP_RE,
  stripMentionSyntax,
} from '@/components/tiptap/mention-types';

/**
 * Text normalization helpers for the composer's serialized editor content.
 */

export function stripDanglingMentionTriggers(text: string): string {
  return text
    .replace(/(^|\s)@+(?=\s|$)/g, '$1')
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/ *\n */g, '\n')
    .trim();
}

export function getVisiblePromptText(text: string): string {
  return stripDanglingMentionTriggers(
    stripMentionSyntax(text.replace(FILE_CHIP_RE, ''))
  );
}

/** Keep selected chat identities in the request, rather than promoting their titles to prose. */
export function getSubmissionPromptText(text: string): string {
  return stripDanglingMentionTriggers(
    text
      .split(/(\[@[^\]]+\]\(thread:[^)]+\))/g)
      .map((part, index) =>
        index % 2 ? part : stripMentionSyntax(part.replace(FILE_CHIP_RE, ''))
      )
      .join('')
  );
}

export function toAssistantMetadataInstruction(text: string): string {
  return `metadata: ${JSON.stringify({ message_to_assistant: text.trim() })}`;
}

export function ensureAssistantMetadataInstruction(text: string): string {
  const trimmed = text.trim();
  if (!trimmed) return '';

  const nonEmptyLines = trimmed
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
  if (nonEmptyLines.every((line) => line.startsWith('metadata:'))) {
    return trimmed;
  }

  return toAssistantMetadataInstruction(trimmed);
}
